export default __webpack_public_path__ + "static/media/WMT.f9036a84.svg";